if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const quantityInput = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`)
        || this.form.querySelector('[name="quantity"]')
        || (this.dataset.sectionId ? document.querySelector(`#Quantity-${this.dataset.sectionId}`) : null);
      if (quantityInput) {
        const cartQty = quantityInput.dataset.cartQuantity ? parseInt(quantityInput.dataset.cartQuantity) : 0;
        const maxAttr = (quantityInput.getAttribute('max') !== null && quantityInput.getAttribute('max') !== '') ? parseInt(quantityInput.getAttribute('max')) : null;
        const limitAttr = quantityInput.dataset.limit ? parseInt(quantityInput.dataset.limit) : (quantityInput.dataset.max ? parseInt(quantityInput.dataset.max) : null);
        const reqQty = parseInt(new FormData(this.form).get("quantity") || 1);

        if (limitAttr !== null) {
          if (cartQty >= limitAttr || (maxAttr !== null && maxAttr <= 0)) {
            this.handleErrorMessage(`You have already reached the maximum purchase limit of ${limitAttr} for this product.`);
            return;
          }
          if (cartQty + reqQty > limitAttr) {
            const allowed = limitAttr - cartQty;
            this.handleErrorMessage(`You can only add up to ${allowed} more of this product (maximum limit is ${limitAttr}).`);
            return;
          }
        }
      }

      if(this.querySelectorAll('product-variant'))
      {
        this.submitButton.setAttribute('aria-disabled', false);
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
      }

      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const activeVariantContainer = this.submitButton.closest('product-variant');
      if(activeVariantContainer){
       activeVariantContainer?.classList.add('active');
  
        const variants = document.querySelectorAll('product-variant');
        if(variants){
          variants.forEach(variant => {
            if (!variant.classList.contains('active')) {
              variant.classList.add('inactive');
            }
          });
        }
      }
     
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // Fetch the product ID of the current form
      const baseProductId = this.dataset.productId;

      // Initialize bundleData
      let bundleData = {
        items: [],
        sections: [],
        sections_url: "",
      };

      // Handle bundle data if checkboxes are checked
      const checkedCheckboxes = document.querySelectorAll('input[type="checkbox"][name="bundle_checkbox"]:checked');

      // Use filter and map to process only relevant checkboxes and create the items array
      const checkedVariantIds = Array.from(checkedCheckboxes)
        .filter((checkbox) => checkbox.dataset.baseProduct === baseProductId)
        .map((checkbox) => ({
          id: parseInt(checkbox.value),
          quantity: 1,
        }));

      if (checkedVariantIds.length > 0) {
        // If checkboxes are checked, use both the main product and bundle product(s)
        bundleData.items.push({
          id: parseInt(formData.get("id")),
          quantity: parseInt(formData.get("quantity") || 1),
        });

        bundleData.items = bundleData.items.concat(checkedVariantIds);
      } else {
        // If no checkboxes are checked, use only the main product
        bundleData.items.push({
          id: parseInt(formData.get("id")),
          quantity: parseInt(formData.get("quantity") || 1),
        });
      }

      // Include sections data if cart exists
      if (this.cart) {
        bundleData["sections"] = this.cart
          .getSectionsToRender()
          .map((section) => section.id);
        bundleData["sections_url"] = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      // Adjust the request based on whether bundle items are added
      config.body = JSON.stringify(bundleData);
      config.headers["Content-Type"] = "application/json";

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');

          if(activeVariantContainer){
           activeVariantContainer?.classList.remove('active');
      
            const variants = document.querySelectorAll('product-variant');
            if(variants){
              variants.forEach(variant => {
                if (variant.classList.contains('inactive')) {
                  variant.classList.remove('inactive');
                }
              });
            }

            let variantATCPlus = activeVariantContainer.querySelector('.variant__plus');
            let variantATCTick = activeVariantContainer.querySelector('.variant__tick');
            if(activeVariantContainer){
              variantATCPlus?.classList.add('hidden');
              variantATCTick?.classList.remove('hidden');
            }
          }

          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper
        || this.querySelector('.product-form__error-message-wrapper')
        || (this.form && this.form.querySelector('.product-form__error-message-wrapper'))
        || (this.dataset.sectionId && document.querySelector(`#ProductInfo-${this.dataset.sectionId} .product-form__error-message-wrapper`))
        || document.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        } else {
          this.errorMessageWrapper.textContent = errorMessage;
        }
      }
    }
  }
  customElements.define('product-form',ProductForm);
  window.ProductForm = ProductForm;
}
